export default "__VITE_ASSET__6b705044__"